import React, { useEffect, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaCoins } from 'react-icons/fa';

// ✅ Styled Components
const StyledContainer = styled(Container)`
  background-color: #000;
  color: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const CoinsIcon = styled(FaCoins)`
  font-size: 60px;
  color: #FFB800;
  margin-bottom: 20px;
`;

const CoinText = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const RewardMessage = styled.div`
  border: 2px solid #FF4D4D;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: bold;
  color: #FF4D4D;
  border-radius: 10px;
  margin-bottom: 20px;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  width: 80%;
  max-width: 300px;
`;

const PostActivationStreakCommitRewardPage = () => {
  const navigate = useNavigate();
  const [coins, setCoins] = useState(0);

  // ✅ Increment coins animation from 0 to 10
  useEffect(() => {
    let counter = 0;
    const interval = setInterval(() => {
      counter += 1;
      setCoins(counter);
      if (counter === 10) {
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const handleContinue = () => {
    navigate('/course-landing'); // ✅ Navigate to Course Landing Page
  };

  return (
    <StyledContainer>
      {/* ✅ Animated Coins Icon */}
      <CoinsIcon />

      {/* ✅ Coins Earned Message */}
      <CoinText>You have earned {coins} coins</CoinText>

      {/* ✅ Reward Message */}
      <RewardMessage>Good job in reaching daily goal</RewardMessage>

      {/* ✅ Continue Button */}
      <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default PostActivationStreakCommitRewardPage;
